import http from '@/utils/http';

import { GameSegmentType, BenchmarkGameResponse, VidoeBenchmarkRankResponse, FigureDataResponse, BenchmarkGameItem } from './types';

//获取benchmark列表
export function getTopChartsVidoeBenchmarkRankList(params:any, config?:{ [key: string]: any }): Promise<VidoeBenchmarkRankResponse> {
  return http(`/api/v1/intelligence_pc/TopChartsVidoeBenchmarkRankList`, {
    ...config,
    method: 'post',
    rawData: true,
    data: {
      ...params,
      entity_type: 'pc',
      genre_source: 'iegg',
      entity_types: ['pc', 'console'],
      company: [],
      source_metrics: {},
    },
  });
}


// 获取游戏列表
export function getVidoeBenchmarkGameList(params: {
  entity_type: string[];
  genre_type: GameSegmentType[];
}): Promise<BenchmarkGameResponse> {
  return http(`/api/v1/intelligence_pc/vidoeBenchmarkGameList`, {
    method: 'post',
    data: {
      ...params,
    },
  });
}

// 获取总的游戏列表
export function getVidoeBenchmarkAllGameList(params: {
  entity_type: string[];
  genre_type: GameSegmentType[];
}): Promise<BenchmarkGameResponse[]>{
  return http(`/api/v1/intelligence_pc/vidoeBenchmarkAllGameList`, {
    method: 'post',
    data: {
      ...params,
    },
  });
}

// 配置定义游戏列表
export function addVidoeBenchmarkCustomizeGame(params: {
  game_ids: string[];
  genre_type: string;
  is_url: boolean
}): Promise<any> {
  return http(`/api/v1/intelligence_pc/addVidoeBenchmarkCustomizeGame`, {
    method: 'post',
    data: {
      ...params,
    },
  });
}


// 下载
export function downloadVidoeBenchmarkMetricsExcel(params:any): Promise<ArrayBuffer> {
  return http(/*'/api/v1/intelligence_pc/topChartVidoeBenchmarkMetricsExcel'*/
  '/api/v1/intelligence_pc/topChartVideoBenchmarkMetricsExcel', {
    method: 'post',
    rawData: true,
    data: {
      ...params,
      entity_type: 'pc',
      source_metrics: {},
      iegg_genre_req: [],
      file_format: 0,
      company: [],
      file_name: 'video_benchmark'
    },
    timeout: 2 * 60 * 1000,
    httpResponses: true,
    responseType: 'arraybuffer',
  });
}


// 获取游戏列表
export function getVidoeBenchmarkFigured(params: {
  entity_type: string[];
  genre_type: GameSegmentType[];
}): Promise<FigureDataResponse> {
  return http(`/api/v1/intelligence_pc/TopChartsVidoeBenchmarkFigure`, {
    method: 'post',
    data: {
      ...params,
      entity_type: 'pc',
      genre_source: 'iegg',
      entity_types: ['pc', 'console'],
    },
  });
}

export function getCollectionGroupByEntityTypes(entity_types: string[], get_detail = true){
  return http(`/api/v1/intelligence_pc/collectionGroupGamesByEntityTypes`, {
    method: 'post',
    data: {
      entity_types,
      get_detail
    }
  })
}


export function followingCollectionGames(params: {
  game_company_ids: {[key: string]: string[]};
  entity_types: string[];
  group_name: string;
  is_overwrite: boolean;
  is_collection: boolean
}){
  return http(`/api/v1/intelligence_pc/followingCollectionGames`, {
    method: 'post',
    data: {
      ...params
    }
  })
}
